import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    inputColor:{
        boxSizing: 'border-box',
        '& ul': {
            padding: 0,
            margin: 0,
        },        
        '&>.MuiAutocomplete-inputRoot':{
            color: 'blue',
        },
    },
    checkedColorDefaultBorder:{
        color: 'green',
        marginRight:8,
        '&>.MuiAutocomplete-inputRoot':{
            color: 'blue',
        },
    },
    checkedBoxColorSelect:{
        color: 'blue',
    }, 
}))